const page_schema = {
	"tiers": [
		{
			"name": "Applications",
			"type": "checkbox",
			"id": "applications",
			"class_name": "tags",
			"child_name": "application",
			"options": [
				{
					"name": "Bacteria",
					"id": "bacteria"
				},
				{
					"name": "Fungi",
					"id": "fungi"
				},
				{
					"name": "Archaea",
					"id": "archaea"
				},
				{
					"name": "Feces",
					"id": "feces"
				},
				{
					"name": "Soil",
					"id": "soil"
				},
				{
					"name": "Saliva",
					"id": "saliva"
				},
				{
					"name": "Skin",
					"id": "skin"
				},
				{
					"name": "Vaginal",
					"id": "vaginal"
				},
				{
					"name": "Tissue",
					"id": "tissue"
				},
				{
					"name": "Water",
					"id": "water"
				},
				{
					"name": "Plants",
					"id": "plants"
				},
				{
					"name": "Insects",
					"id": "insects"
				},
				{
					"name": "Urine",
					"id": "urine"
				},
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "DNA",
					"id": "dna"
				},
				{
					"name": "RNA",
					"id": "rna"
				},
				{
					"name": "CE-IVD",
					"id": "ce-ivd"
				},
				{
					"name": "High-Throughput",
					"id": "high-throughput"
				},
				{
					"name": "Low Input",
					"id": "low-input"
				},
				{
					"name": "High Molecular Weight DNA",
					"id": "high-molecular-weight-dna"
				},
				{
					"name": "Host Depletion",
					"id": "host-depletion"
				},
				{
					"name": "Low Bioburden for Metagenomics",
					"id": "low-bioburden-for-metagenomics"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Column Purification",
					"id": "column-purification"
				},
				{
					"name": "Magbead Purification",
					"id": "magbead-purification"
				},
				{
					"name": "96-Well Spin Plate",
					"id": "96-well-spin-plate"
				},
			]
		},
		{
			"name": "Collections",
			"type": "checkbox",
			"id": "collections",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "ZymoBIOMICS DNA Kits",
					"id": "zymobiomics-dna-kits"
				},
				{
					"name": "ZymoBIOMICS RNA Kits",
					"id": "zymobiomics-rna-kits"
				},
				{
					"name": "ZymoBIOMICS DNA/RNA Kits",
					"id": "zymobiomics-dna-rna-kits"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"ZymoBIOMICS DNA Miniprep Kit": {
			"title": "ZymoBIOMICS DNA Miniprep Kit",
			"catalogNumbers": "D4300, D4300T, D4304",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae) making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-dna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg?v=1628532366&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"tissue",
				"water",
				"plants",
				"insects",
				"dna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS DNA Microprep Kit": {
			"title": "ZymoBIOMICS DNA Microprep Kit",
			"catalogNumbers": "D4301, D4305",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae) making it ideal for microbial community profiling. Uniform mechanical lysis of tough microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-dna-microprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg?v=1628532363&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"saliva",
				"skin",
				"vaginal",
				"urine",
				"dna",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS 96 Magbead DNA Kit": {
			"title": "ZymoBIOMICS 96 Magbead DNA Kit",
			"catalogNumbers": "D4302, D4306, D4308",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.jpg?v=1668718447&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS 96 MagBead DNA Kit – Dx": {
			"title": "ZymoBIOMICS 96 MagBead DNA Kit – Dx",
			"catalogNumbers": "D4302-E, D4306-E, D4308-E",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.jpg?v=1668718447&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"ce-ivd",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS 96 DNA Kit": {
			"title": "ZymoBIOMICS 96 DNA Kit",
			"catalogNumbers": "D4303, D4307, D4309",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-dna-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png?v=1628532361&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"96-well-spin-plate",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"HostZERO Microbial DNA Kit": {
			"title": "HostZERO Microbial DNA Kit",
			"catalogNumbers": "D4310",
			"description": "The HostZERO Microbial DNA Kit is designed to overcome the challenge of contaminating host nucleic acids in microbial samples. This kit uses a novel method to reduce the amount of contaminating host DNA by selectively lysing the eukaryotic cells and degrading this DNA prior to total DNA purification. Paired with Zymo Research’s non-biased purification technology, the HostZERO Microbial DNA Kit allows for the exclusive capture of DNA from living microbial cells in a biological sample. This new technology is able to reduce the presence of human DNA in a saliva sample from 65% (untreated sample) to less than 1% (treated sample). Concurrently, the depletion process utilizes the ZymoBIOMICS non-biased DNA isolation technology for accurate data representation. Finally, the HostZERO Microbial DNA Kit recovers the highest amount of bacterial DNA as compared to other methods. By removing the presence of host DNA and reducing bias in purification, the HostZERO Microbial DNA Kit produces the highest-quality data for microbial samples.",
			"handle": "/products/hostzero-microbial-dna-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4310-A_HostZERO-Microbial-DNA-Kit.jpg?v=1628532417&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"urine",
				"dna",
				"low-input",
				"host-depletion",
				"low-bioburden-for-metagenomics",
				"column-purification",
			],
			filters: []
		},
		"Load N' Go ZymoBIOMICS DNA MagBead Kit": {
			"title": "Load N' Go ZymoBIOMICS DNA MagBead Kit",
			"catalogNumbers": "D4311",
			"description": "The Load N' Go ZymoBIOMICS DNA MagBead Kit is a cutting-edge solution for efficient and unbiased nucleic acid extraction from a wide range of samples.",
			"handle": "/products/load-n-go-zymobiomics-dna-magbead-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4311-Load-N_-Go-ZymoBIOMICS-DNA-MagBead_1200x.jpg",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"zymobiomics-dna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS RNA Miniprep Kit": {
			"title": "ZymoBIOMICS RNA Miniprep Kit",
			"catalogNumbers": "R2001",
			"description": "The ZymoBIOMICS RNA Miniprep Kit is designed for purifying RNA from a wide array of sample inputs that is ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae). The procedure uses Zymo-Spin Column technology that results in high-quality total RNA (including small RNAs 17-200 nt) that is free of PCR inhibitors and is ready for RT-PCR, hybridization, sequencing, etc. DNase I included.",
			"handle": "/products/zymobiomics-rna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg?v=1628532353&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"rna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"zymobiomics-rna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS DNA/RNA Miniprep Kit": {
			"title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
			"catalogNumbers": "R2002",
			"description": "The ZymoBIOMICS DNA/RNA Miniprep Kit is designed for purifying DNA and RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms) that is ready for microbiome or metagenome analyses. The ZymoBIOMICS innovative lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae). The provided DNA/RNA Shield preserves nucleic acids at ambient temperatures, providing an unbiased molecular snapshot of the sample. The procedure uses Zymo-Spin Column technology that results in high-quality DNA and total RNA (including small RNAs 17-200 nt) that is free of PCR inhibitors (e.g. polyphenols, humic acids, and fulvic acids). Ready for RT-PCR, arrays, sequencing, etc.",
			"handle": "/products/zymobiomics-dna-rna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg?v=1628532356&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"rna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"zymobiomics-dna-rna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS MagBead DNA/RNA": {
			"title": "ZymoBIOMICS MagBead DNA/RNA",
			"catalogNumbers": "R2135, R2136",
			"description": "The ZymoBIOMICS MagBead DNA/RNA kit provides a high-throughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample. The provided DNA/RNA Shield inactivates infectious agents and is ideal for sample storage at ambient temperatures. The extraction method utilizes magnetic beads for DNA/RNA extraction without the use of phenol and is eluted into ≥50 µl of ZymoBIOMICS DNase/RNase-Free Water. DNA/RNA is ready for any downstream application including Next-Gen Sequencing, RT-qPCR, etc. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/products/zymobiomics-magbead-dna-rna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2135_zymobiomics_96_magbead_dna_rna_kit.png?v=1628532421&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"rna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"zymobiomics-dna-rna-kits"
			],
			filters: []
		},
		"ZymoBIOMICS MagBead RNA": {
			"title": "ZymoBIOMICS MagBead RNA",
			"catalogNumbers": "R2137, R2138",
			"description": "The ZymoBIOMICS MagBead RNA kit provides a high-throughput, magnetic beadbased purification of total RNA (including small/microRNAs) from any sample source (e.g., microbes including gram positive/negative bacteria, fungi, protozoans, viruses, fecal, soil, plant, water, biofilms, swabs, saliva, body fluids and etc.). The provided DNA/RNA Shield inactivates infectious agents and is ideal for sample storage at ambient temperatures. Total RNA is eluted into ≥50 µl of ZymoBIOMICS DNase/RNase-Free Water and is ready for any downstream application including Next-Gen Sequencing, RT-qPCR, etc. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/products/zymobiomics-magbead-rna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2137_zymobiomics-magbead-rna-kit.png?v=1628532421&width=600",
			"generalIndex": "998",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"rna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"zymobiomics-rna-kits"
			],
			filters: []
		},
		// "ZR BashingBead Lysis Tubes (2 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (2 mm)",
		// 	"catalogNumbers": "S6003-50",
		// 	"description": "2mL tubes containing ultra-high density 2mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashing-bead-lysis-tubes",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
		// 	"catalogNumbers": "S6012-50",
		// 	"description": "2mL tubes containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)": {
		// 	"title": "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
		// 	"catalogNumbers": "S6014-50",
		// 	"description": "2mL tubes containing ultra-high density 0.1 and 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5.png?v=1628532422&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZymoBIOMICS BashingBead Lysis Rack (0.5 mm & 0.1 mm)": {
		// 	"title": "ZymoBIOMICS BashingBead Lysis Rack (0.5 mm & 0.1 mm)",
		// 	"catalogNumbers": "S6002-96-7",
		// 	"description": "96-well lysis rack containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/products/zymobiomics-bashingbead-lysis-rack",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/S6002-96-6_ZymoBIOMICSLysisRack.jpg?v=1706039540&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR-96 BashingBead Lysis Rack (Single barcoded Tubes)": {
		// 	"title": "ZR-96 BashingBead Lysis Rack (Single barcoded Tubes)",
		// 	"catalogNumbers": "S6002-96-4",
		// 	"description": "96 individually barcoded and screw capped lysis tubes in a single rack, containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/products/zr-96-bashingbead-lysis-rack-barcoded",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR-96 BashingBead Lysis Rack (Double barcoded Tubes)": {
		// 	"title": "ZR-96 BashingBead Lysis Rack (Double barcoded Tubes)",
		// 	"catalogNumbers": "S6002-96-5",
		// 	"description": "96 individually barcoded and screw capped lysis tubes in a single rack, containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
		// 	"handle": "/products/zr-96-bashingbead-lysis-rack-barcoded",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/s6002_96_lysis_rack.jpg?v=1672171183&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ZR BashingBead Lysis/Filtration Tubes": {
		// 	"title": "ZR BashingBead Lysis/Filtration Tubes",
		// 	"catalogNumbers": "S6010, S6011",
		// 	"description": "50 ml conical tube containing ultra-high density 0.5mm or 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tissues or microbes",
		// 	"handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-filtration-tubes",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6010_ZR-BashingBead-Lysis-Filtration-Tube---50-mL.jpg?v=1628532394&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Bunny Wipe Fecal Sample Collector": {
		// 	"title": "Bunny Wipe Fecal Sample Collector",
		// 	"catalogNumbers": "R1133-1, R1133-10, R1138, R1101",
		// 	"description": "A fecal collection device that mimics toilet paper to provide comfortable, user-friendly collection. Samples are stabilized in pre-filled DNA/RNA Shield and ready for transport or storage.",
		// 	"handle": "/collections/fecal-collection/products/bunny-wipe-fecal-sample-collector",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Wipe___Tube.jpg?v=1677089410&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Feces Catcher": {
		// 	"title": "Feces Catcher",
		// 	"catalogNumbers": "R1101-1-10",
		// 	"description": "A hygienic, flushable strip of fecal collection paper that fits onto any toilet seat for easy fecal collection",
		// 	"handle": "/collections/fecal-collection/products/feces-catcher",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-1-10_Feces-Catcher.jpg?v=1671135398&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "ColOff (Stool Collection Device)": {
		// 	"title": "ColOff (Stool Collection Device)",
		// 	"catalogNumbers": "R1101-2-5",
		// 	"description": "A hygienic, disposable, easy-to-use stool collection facilitation device. It is a plastic sleeve that facilitates stool collection in a physiological position (sitting on the toilet seat).",
		// 	"handle": "/collections/fecal-collection/products/coloff-stool-collection-device",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-2-5_Coloff-Stool-Collection-Device.jpg?v=1671135003&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Sterile Collection Swab": {
		// 	"title": "Sterile Collection Swab",
		// 	"catalogNumbers": "C1052-50, C1053-50",
		// 	"description": "Individually packaged sterile fiber swabs for the collection of samples from the mouth, nose, and throat for research and pre-analytical diagnostic use. 20mm Break Point",
		// 	"handle": "/collections/swab-collection/products/sterile-collection-swab",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1052-50_Zymo_20Collection_20Swab_20-_2020_20mm_20Break_20Point.png?v=1628532409&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
		// "Urine Collection Cup": {
		// 	"title": "Urine Collection Cup",
		// 	"catalogNumbers": "D3062-1",
		// 	"description": "Small and easy-to-use plastic urine collection cups for research labs collecting urine specimens.",
		// 	"handle": "/collections/urine-collection/products/urine-collection-cup",
		// 	"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062-1_Urine-Collection-Cup_1ddcf228-f40e-461a-9319-238eab6650ae.jpg?v=1628532367&width=600",
		// 	"generalIndex": "998",
		// 	"tags": [
		// 		"accessories",
		// 	],
		// 	filters: []
		// },
	}
}